import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=4a12e3ec&scoped=true"
import script from "./privacy-policy.vue?vue&type=script&lang=js"
export * from "./privacy-policy.vue?vue&type=script&lang=js"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=4a12e3ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a12e3ec",
  null
  
)

export default component.exports